<template>
  <div class="index full-page-container">
    <div class="container-fluid full-page bg">
      <div class="row">
        <div class="header col-12 justify-content-center">
          <h1 class="title brand display-2">Fontane Labs</h1>
        </div>

        <div class="col-12 justify-content-center">
          <h3 id="subtitle">
            {{$t('subtitle')}}
          </h3>
        </div>
      </div>
      <div class="scroll-indicator row">
        <div class="col-12 justify-content-center">
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>
    </div>

    <a name="mission"></a>
    <div class="container-fluid full-page" id="mission">
      <div class="row">
        <div class="header col-12 justify-content-center">
          <h1 class="title display-3">{{$t('mission.title')}}</h1>
        </div>

        <div class="col-12 justify-content-center text">
          <i18n path="mission.p1" tag="p"></i18n>

          <i18n path="mission.p2" tag="p">
            <b>Spring</b>
          </i18n>

          <i18n path="mission.p3" tag="p"></i18n>

          <router-link to="team">
            <button id="btn-team" class="btn btn-lg btn-outline-dark">
              {{$t('meet_the_team')}}
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <a name="contact"></a>
    <div class="container-fluid full-page bg" id="contact-container">
      <contact/>
    </div>
  </div>
</template>

<i18n src='@/assets/locales/shared.json'></i18n>

<i18n>
en:
  subtitle: digitally rewiring mental health care
  mission:
    title: Mission
    p1: |
      Our mission is to digitally rewire mental health care. We currently focus on
      affective disorders, the globally leading cause of years lost due to disability,
      and projected main cause of premature death in industrialised countries by 2030.
    p2: |
      In co-creation with students and young professionals we develop
      {0}, a digital tool that helps users
      safely and seamlessly monitor, manage and communicate their emotional health to a
      reality of constant change and a culture of perfection.
    p3: |
      Our vision is to foster a community around emotional self-care and advance the
      prevention of related illnesses.
  meet_the_team: Meet the team
de:
  subtitle: digitally rewiring mental health care
  mission:
    title: Mission
    p1: |
      Ziel von Fontane Labs ist es intelligente Verfahren zur digitalen Prävention
      chronischer Beschwerden, insbesondere im Bereich der mentalen und emotionalen
      Gesundheit, auf das Individuum fokussiert zu entwerfen, zu entwickeln und zu
      validieren.
      Unsere Mission: ungenutztes wissenschaftliches Potenzial erkennen und den
      Bogen zu den gesundheitlichen Bedürfnissen unserer Nutzer spannen.
    p2: |
      Gemeinsam mit unseren zukünftigen Nutzern entwickeln wir {0}, eine digitale
      Lösung zum Aufbau, zur Vermessung und zur Kommunikation emotionaler Gesundheit.
      Dies ist unsere Antwort auf das Bedürfnis nach Selbstfindung in tiefgreifenden
      persönlichen Veränderungsprozessen und in einer perfektionistischen Gesellschaft.
    p3: |
      Unsere Vision ist die Stärkung einer Gesellschaft, die emotionale Selbsversorgung
      und Prävention von mentalen Krankheiten als essentiell betrachtet.
  meet_the_team: Das Team
</i18n>

<script>
import contact from '@/components/Contact';

export default {
  name: 'Index',
  data() {
    return {

    };
  },
  components: {
    contact,
  },
};
</script>

<style scoped lang="scss">
.row {
  text-align: center;
}

h1.title {
  text-transform: uppercase;
  text-align: center;
  margin-top: 150px;
  user-select: none;
  color: #343a40;
}

h1.title.brand {
  color: #c33;
  font-weight: 500;
}

.header {
  margin-top: 50px;
  margin-bottom: 10px;
}

button {
  text-transform: uppercase;
  margin-top: 100px;
}

#subtitle {
  color: #000;
  margin-bottom: 150px;
  font-weight: 100;
  user-select: none;
  color: #343a40;
}

@media (max-width: 567.99px) {
  h1.title {
    font-size: 3rem;
    font-weight: 300;
    margin-top: 150px;
  }

  h1.title.brand {
    font-weight: 400;
  }

  #subtitle {
    font-size: 1.5rem;
    margin-bottom: 50px;
  }
}

@media (max-width: 375.99px) {
  h1.title {
    font-size: 2.5rem;
    font-weight: 200;
    margin-top: 100px;
  }

  h1.title.brand {
    font-weight: 400;
  }

  #subtitle {
    font-size: 1rem;
    margin-bottom: 10px;
  }

  button {
    margin-top: 50px;
    font-size: 1rem;
  }
}

.scroll-indicator {
  position: absolute;
  bottom: 32px;
  width: 100%;
}

.bg {
  background-color: rgb(242, 243, 238);
  // Fontane Labs orange: #ffc107;
}

#mission {
  padding-top: 50px;
  padding-bottom: 150px;

  background: url(../../static/images/mission.jpg) repeat left top fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

#contact-container {
  padding-top: 50px;
  padding-bottom: 50px;
}

.text > p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  color: #343a40;
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue